import React, { useState, useEffect } from 'react';
import { Typography, Steps, Checkbox, Modal, Button, DatePicker, Tooltip, Divider } from 'antd';
import { useTranslation } from 'react-i18next';
import {
	CheckCircleOutlined,
	CheckOutlined,
	DownloadOutlined,
	InfoCircleFilled,
	InfoCircleOutlined
} from '@ant-design/icons';
import { isMobileOnly } from 'react-device-detect';
import axios from 'axios';
import env from '../../../environment';
import { useSelector } from 'react-redux';
import dayjs from 'dayjs';
import { refreshData } from '../../../store/auth/actions';
import { trace } from '../../../components/tagmanager';
import { useLocation } from 'react-router-dom';
import tagSabadell from '../../../components/tagSabadell';
import _ from 'lodash';
import { Calendar03Icon, PermanentJobIcon } from 'hugeicons-react';
import moment from 'moment';

const { Text } = Typography;
const { Step } = Steps;

const FormalizationOffice = ({
	dataMortgage,
	operationId,
	existAppraisal,
	docsNumber,
	handleChangeCollapse
}) => {
	const { t, i18n } = useTranslation();
	const userToken = useSelector((state) => state.auth.token);
	const [feinIssued, setFeinIssued] = useState(undefined);
	const [feinSigned, setFeinSigned] = useState(undefined);
	const [estimatedSignDate, setEstimatedSignDate] = useState(undefined);
	const [finishStep, setFinishStep] = useState(false);
	const [isModalVisible, setIsModalVisible] = useState(false);
	const showPayBoolean = useSelector((state) => state.data.showPay);
	const [checkBoxSigned, setCheckBoxSigned] = useState(dataMortgage?.mortgage?.signed);
	const [mortgageData, setMortgageData] = useState();
	const operations = useSelector((state) => state.auth.operations);
	const nameOperations =
		operations !== undefined &&
		operations.find((operation) => operation.operationId === operationId);
	const rol = useSelector((state) => state.auth.roles);
	const location = useLocation();
	const [symphonyData, setSymphonyData] = useState(undefined);

	useEffect(() => {
		getMortgageData();
		trace({
			location,
			userToken,
			rol,
			stage: 'formalization',
			operationName: nameOperations && nameOperations.name
		});

		tagSabadell('formalizacion paso 2', i18n.language === 'cat' ? 'ca' : 'es');
	}, []);
	const getMortgageData = async () => {
		try {
			const response = await axios.get(`${env.api.url}/v1/mortgages/data/get/${operationId}`, {
				headers: { Authorization: `Bearer ${userToken}` }
			});

			const { mortgage } = response.data.data;
			setMortgageData(mortgage);
			setSymphonyData(response.data.data.sinfoniaStatusRow || {});
			const isFeinIssued =
				!_.isNil(_.get(mortgage, 'docFeinIssued')) && _.get(mortgage, 'docFeinIssued') !== false;
			const isFeinSigned =
				!_.isNil(_.get(mortgage, 'signedDocumentation')) &&
				_.get(mortgage, 'signedDocumentation') !== false;

			setFeinIssued(isFeinIssued);
			setFeinSigned(isFeinSigned);
			setEstimatedSignDate(_.get(mortgage, 'estimatedSignDate', false));
		} catch (error) {
			console.error('Error fetching mortgage data:', error);
		}
	};

	const saveData = (participant, key, value) => {
		axios
			.post(
				`${env.api.url}/v1/mortgages/data/update/${operationId}`,
				{ key, participant, value },
				{ headers: { Authorization: `Bearer ${userToken}` } }
			)
			.then((response) => {
				if (response.data.success) {
					getMortgageData();
					refreshData();
					setCheckBoxSigned(response.data.data.mortgage.signed);
				}
			});

		if (key === 'signed' && value) {
			setIsModalVisible(true);
			tagSabadell('formalizacion confirmacion', i18n.language === 'cat' ? 'ca' : 'es');
		}
		if (key === 'signedDocumentation' && value === true) {
			setFinishStep(true);
		}
	};

	return (
		<div>
			<Steps
				labelPlacement="vertical"
				className={isMobileOnly ? 'formalization-steps-mobile' : 'formalization-steps'}
				responsive={true}>
				<Step
					title={
						<>
							<Text style={{ color: '#424242', fontSize: 16, fontWeight: 500 }}>
								{t('formalization.controlScoring')}
							</Text>
							&nbsp;
							<Tooltip title={t('formalization.controlScoring')}>
								<InfoCircleOutlined style={{ color: '#006DFF' }}></InfoCircleOutlined>
							</Tooltip>
						</>
					}
					description={
						<div
							style={{
								alignItems: 'center'
							}}></div>
					}></Step>
				<Step
					title={
						<>
							<Text style={{ color: '#424242', fontSize: 16, fontWeight: 500 }}>
								{t('steps.formalizacionOffice2')}
							</Text>
							&nbsp;
							<Tooltip title={t('steps.formalizacionOffice2Text')}>
								<InfoCircleOutlined style={{ color: '#006DFF' }}></InfoCircleOutlined>
							</Tooltip>
						</>
					}
					status="process"
					description={
						symphonyData?.fechaIjAceptado && (
							<div
								style={{
									alignItems: 'center'
								}}>
								<CheckCircleOutlined
									style={{
										color: '#008626',
										fontSize: 14,
										fontWeight: 500
									}}></CheckCircleOutlined>{' '}
								&nbsp;
								<Text style={{ color: '#008626', fontSize: 14, fontWeight: 500 }}>
									{t('formalizarion.officeCheck')}
								</Text>{' '}
								&nbsp;
								<Text style={{ color: '#757575', fontSize: 10, fontWeight: 500 }}>
									{moment(symphonyData?.fechaIjAceptado).format('DD MMM YYYY')}
								</Text>
							</div>
						)
					}></Step>
				<Step
					title={
						<>
							<Text style={{ color: '#424242', fontSize: 16, fontWeight: 500 }}>
								{t('steps.formalizacionOffice3')}
							</Text>
							&nbsp;
							<Tooltip title={t('steps.formalizacionOffice3Text')}>
								<InfoCircleOutlined style={{ color: '#006DFF' }}></InfoCircleOutlined>
							</Tooltip>
						</>
					}
					status="process"
					description={
						symphonyData?.fechaTasAceptada && (
							<div
								style={{
									alignItems: 'center'
								}}>
								<CheckCircleOutlined
									style={{
										color: '#008626',
										fontSize: 14,
										fontWeight: 500
									}}></CheckCircleOutlined>{' '}
								&nbsp;
								<Text style={{ color: '#008626', fontSize: 14, fontWeight: 500 }}>
									{t('formalizarion.officeCheck')}
								</Text>{' '}
								&nbsp;
								<Text style={{ color: '#757575', fontSize: 10, fontWeight: 500 }}>
									{moment(symphonyData?.fechaTasAceptada).format('DD MMM YYYY')}
								</Text>
							</div>
						)
					}></Step>
				<Step
					title={
						<>
							<Text style={{ color: '#424242', fontSize: 16, fontWeight: 500 }}>{'FEIN'}</Text>
							&nbsp;
							<Tooltip title={t('steps.formalizacionOffice4Text')}>
								<InfoCircleOutlined style={{ color: '#006DFF' }}></InfoCircleOutlined>
							</Tooltip>
						</>
					}
					status="process"
					description={
						symphonyData?.fechaFeinFirmada && (
							<div
								style={{
									alignItems: 'center'
								}}>
								<CheckCircleOutlined
									style={{
										color: '#008626',
										fontSize: 14,
										fontWeight: 500
									}}></CheckCircleOutlined>{' '}
								&nbsp;
								<Text style={{ color: '#008626', fontSize: 14, fontWeight: 500 }}>
									{t('formalizarion.officeCheck')}
								</Text>{' '}
								&nbsp;
								<Text style={{ color: '#757575', fontSize: 10, fontWeight: 500 }}>
									{moment(symphonyData?.fechaFeinFirmada).format('DD MMM YYYY')}
								</Text>
							</div>
						)
					}></Step>
				<Step
					title={
						<>
							<Text style={{ color: '#424242', fontSize: 16, fontWeight: 500 }}>
								{t('steps.formalizacionOffice4')}
							</Text>
							&nbsp;
							<Tooltip title={t('steps.formalizacionOffice1')}>
								<InfoCircleOutlined style={{ color: '#006DFF' }}></InfoCircleOutlined>
							</Tooltip>
						</>
					}
					status="process"
					description={
						<div
							style={{ display: 'flex', flexDirection: 'column', gap: 8 }}
							className="secondary-text">
							<div
								style={{
									display: 'flex',
									flexDirection: 'column',
									alignItems: isMobileOnly ? undefined : 'center',
									gap: 8,
									fontSize: 12
								}}>
								{t('office.dateSing')}
								{estimatedSignDate && (
									<DatePicker
										aria-label={t('formalization.dateEstimated')}
										onChange={(e) => {
											saveData(
												'mortgage',
												'estimatedSignDate',
												dayjs(e, 'DD-MM-YYYY').format('YYYY-MM-DD')
											);
										}}
										defaultValue={
											estimatedSignDate && estimatedSignDate !== 'Invalid Date'
												? dayjs(estimatedSignDate)
												: undefined
										}
										format="DD MMM YYYY"
										suffixIcon={<Calendar03Icon size={13} />}
										placeholder="00 mes 0000"
										style={{ flex: 1, height: 24, maxWidth: isMobileOnly ? 230 : 130 }}
										className="formalization-picker"
									/>
								)}
							</div>
							<div
								style={{
									display: 'flex',
									gap: 8,
									textAlign: 'left'
								}}>
								<PermanentJobIcon size={14} style={{ marginTop: 4 }} />
								<Text style={{ fontSize: 12, fontWeight: 500 }}>
									{t('office.dateSing2') + ' ' + symphonyData?.notaria}
								</Text>
							</div>
							<Text style={{ fontSize: 12, fontWeight: 500, marginLeft: 10 }}>
								Nombre Apellidos del notario
							</Text>

							{symphonyData?.fechaFirma && (
								<div
									style={{
										width: 300,
										textAlign: 'left'
									}}>
									<CheckCircleOutlined
										style={{
											color: '#008626',
											fontSize: 14,
											fontWeight: 500
										}}></CheckCircleOutlined>{' '}
									&nbsp;
									<Text style={{ color: '#008626', fontSize: 14, fontWeight: 500 }}>
										{t('office.dateSing3')}
									</Text>{' '}
									&nbsp;
									<Text style={{ color: '#757575', fontSize: 10, fontWeight: 500 }}>
										{moment(symphonyData?.fechaFirma).format('DD MMM YYYY')}
									</Text>
								</div>
							)}
						</div>
					}></Step>
			</Steps>

			{isMobileOnly && (
				<Divider type="horizontal" style={{ margin: '24px 0', background: '#212121' }} />
			)}
			{docsNumber > 0 && (
				<>
					<div style={{ marginTop: 24, display: 'flex', width: '100%' }}>
						<div
							dangerouslySetInnerHTML={{
								__html: t('formalization.needOffice', {
									docsNumber: docsNumber
								})
							}}
						/>
						<div
							style={{
								flex: 1,
								borderBottom: '1px solid #212121',
								marginLeft: '8px',
								marginBottom: 12
							}}></div>
					</div>
					{isMobileOnly ? (
						<div style={{ margintop: 24 }}>
							<Text style={{ color: '#212121', fontSize: 16, fontWeight: 700 }}>
								{t('formalization.needOffice1')}
							</Text>{' '}
							<Text
								onClick={() => handleChangeCollapse('1')}
								style={{
									color: '#006DFF',
									fontSize: 16,
									fontWeight: 700,
									textDecoration: 'underline',
									cursor: 'pointer'
								}}>
								{t('formalization.needOffice2')}
							</Text>
						</div>
					) : (
						<div style={{ display: 'flex', margintop: 24, justifyContent: 'center' }}>
							<Text style={{ color: '#212121', fontSize: 16, fontWeight: 700 }}>
								{t('formalization.needOffice1')}
							</Text>{' '}
							&nbsp;
							<Text
								role="button"
								tabIndex={0}
								onClick={() => handleChangeCollapse('1')}
								onKeyDown={(e) => {
									if (e.key === 'Enter' || e.key === ' ') {
										e.preventDefault();
										handleChangeCollapse('1');
									}
								}}
								style={{
									color: '#006DFF',
									fontSize: 16,
									fontWeight: 700,
									textDecoration: 'underline',
									cursor: 'pointer'
								}}>
								{t('formalization.needOffice2')}
							</Text>
						</div>
					)}
				</>
			)}
		</div>
	);
};

export default FormalizationOffice;
